import(/* webpackMode: "eager" */ "/app/app/accessibility/page.tsx");
